export class AdminStore {

}

export const admin = new AdminStore()


// WEBPACK FOOTER //
// ./src/modules/admin/stores/AdminStore.ts